import { CurrencyPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { RCIPInspectionRequestVM } from '../../../../data/models/coverage-validator-api-models';
import { ButtonComponent, CardComponent } from '../../../../ui-common';
import { payrollForClass } from '../rcip-wizard.helpers';

@Component({
  selector: 'app-rcip-classes',
  templateUrl: './rcip-classes.html',
  styleUrl: './rcip-classes.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CurrencyPipe, ButtonComponent, CardComponent],
})
export class RcipClasses {
  request = input.required<RCIPInspectionRequestVM>();
  back = output<void>();
  next = output<void>();

  protected classes = computed(() =>
    (this.request().eligibilityStatements?.classStatements ?? []).map((statement) => ({
      ...statement,
      payroll: payrollForClass(statement.classCode, this.request()),
    })),
  );
}
